import { $fontSize, $marginTop, $paddingX, $paddingY, phoneSize } from '@/assets/styles/mediaSize';
import { FC } from 'react';
import { styled } from 'styled-components';
import RobotSortOneItem from './RobotSortOneItem';
import { flexPos } from '@/assets/styles/mixin';
import { color } from '@/assets/styles/var';
import { EFaqKnows, useFaq } from '@/service/useChat';
import { IMessage } from '@/store/messageStore';
import useUserStore from '@/store/userStore';
import { Message } from '@arco-design/web-react';
import useAppStore from '@/store/appStore';
import { useLang } from '@/locales/useLang';

interface IRobotSortTwoProps {
  msgBody: string;
  title?: string;
  messageItem?: IMessage;
}

interface IKnowledgeNameList {
  id: string;
  knowledgePointName: string;
}

const RobotSortTwoWrap = styled.div`
  background-color: #fff;
  ${$paddingX('24rem', '12rem')}
  ${$paddingY('24rem', '12rem')}
  ${$fontSize('28rem', '14rem')}

  border-radius: 0 24rem 24rem 24rem;
  @media (min-width: ${phoneSize}) {
    border-radius: 0 12rem 12rem 12rem;
  }

  max-width: 540rem;
  word-break: break-all;
  overflow-x: auto;

  .link {
    color: ${color.blue};
    ${$fontSize('24rem', '12rem')}
    ${$marginTop('16rem', '8rem')}
    font-weight: bold;
  }
`;

const RobotSortTwo: FC<IRobotSortTwoProps> = (props) => {
  const { getFaqKnows } = useFaq();
  const userStore = useUserStore();
  const appStore = useAppStore();
  const $t = useLang();

  const knowsResult = useMemo<IKnowledgeNameList[]>(() => {
    let res = [];
    try {
      res = JSON.parse(props.msgBody);
      console.log('ress...', res);
    } catch (error) {}

    return res;
  }, [props.msgBody]);

  return (
    <RobotSortTwoWrap>
      <div className="text-28 md:text-14">{props.title}</div>
      <div>
        {knowsResult?.map?.((item) => (
          <a
            onClick={() => {
              if (appStore.isKickOff) {
                Message.info($t('chat_session_status_8'));
                return;
              }

              if (userStore.sessionConfig.sessionId !== props.messageItem?.sessionId) {
                Message.info($t('chat_session_status_29'));
                return;
              }
              getFaqKnows(EFaqKnows.answer, item.id);
            }}
            key={item.id}
            className="link"
          >
            {item.knowledgePointName}
          </a>
        ))}
      </div>
    </RobotSortTwoWrap>
  );
};

export default RobotSortTwo;
